


const iterate=(value,token)=>[
{value:value[token],prop:token,missing:!(token in value)}];


export const PROP_TOKEN={
name:"prop",
valueType:"weakObject",
iterate
};